'use strict';

module.exports = [
    '$mdUtil',
    '$templateRequest',
    '$compile',
    function ($mdUtil, $templateRequest, $compile) {

        return {
            require: ['rmRelatedItemsNotification'],
            restrict: 'E',
            scope: {

                iconElement: '=iconElement',
                dataUrl: '=url',
                index: '=index',
                notificationsFuncs: '=notificationsFuncs',
                notificationsTemplate: '=notificationsTemplate'
            },
            controller: ['$scope', '$element', '$timeout', '$http', '$state', rmRelatedItemsNotification],
            controllerAs: 'ctrl',
            link: function (scope, element, attributes, controllers) {

                let tplUrl = scope.notificationsTemplate || '/partial/app.directives.related_items_notification';
                $templateRequest(tplUrl).then(function (html) {

                    let template = angular.element(html);
                    element.append(template);

                    $compile(template)(scope);

                    let relatedItemsNotificationCtrl = controllers[0];
                    relatedItemsNotificationCtrl.render();
                });
            }
        };

        function rmRelatedItemsNotification($scope, $element, $timeout, $http, $state) {
            const debounceFetch = _.debounce(() => {
                this.fetch();
            }, 500, {maxWait: 2500});

            this.items = [];
            this.timer = null;
            this.render = () => {

                let icon = $element[0].querySelector('.items-warning');
                let iconContainer = $element[0].parentNode.querySelector($scope.iconElement);
                if (iconContainer) {
                    iconContainer.appendChild(icon);
                }

                this.fetch();
            };

            this.notifications = $scope.notificationsFuncs || {};
            this.notifications.update = debounceFetch;

            this.hideOverlay = () => {
                $timeout(function () {
                    $scope.ObjRel.showRelated = false;
                }, 1000);
            };

            this.fetch = () => {

                if (typeof ($scope.dataUrl) !== 'undefined') {
                    if (!$scope.dataUrl($scope.index)) {
                        this.items = [];
                        return;
                    }

                    $http.get($scope.dataUrl($scope.index)).then(
                        (response) => {
                            this.items = response.data;
                        }
                    );
                }
            };


        }
    }];
